import { defineStore } from 'pinia';

export const useUserStore = defineStore('user', {
  state: () => ({
    user: null,
  }),
  actions: {
    setUser(userData) {
      this.user = userData;
    },
    logout() {
      this.user = null;
    },
    hasPermission(permission) {
      return Array.isArray(this.user?.platform_permissions)
        && this.user.platform_permissions.includes(permission);
    },
    hasTeamPermission(permission) {
      const activeTeam = this.activeTeam();
      return Array.isArray(activeTeam?.permissions)
        && activeTeam.permissions.includes(permission);
    },
    activeTeam() {
      if (!this.user?.acct_team_uuid || !Array.isArray(this.user?.teams)) return null;
      return this.user.teams.find((team) => team.uuid === this.user.acct_team_uuid) || null;
    },
    hasActiveTeam() {
      return Boolean(this.activeTeam());
    },
    isPlatformAdmin() {
      return Array.isArray(this.user?.platform_roles)
        && this.user.platform_roles.includes('platform_admin');
    }
  }
});
